import { useLocation } from 'react-router-dom';

// Flow context is derived from the route rather than stored in Redux: the
// incentive/interstitial flows own dedicated routes, and their behaviors
// (decline button, hidden back link, cart marking) must apply only there.
// Membership checks are not a safe substitute for interstitial — an
// interstitial-flagged product is a regular product also purchasable through
// the normal routes. Derived via react-router's useLocation (not
// connected-react-router state, which is being phased out).

export const useIsIncentiveFlow = (): boolean =>
  useLocation().pathname === '/v3/incentives/config';

export const useIsInterstitialFlow = (): boolean =>
  useLocation().pathname === '/v3/interstitial';

export const useIsPreCartOfferFlow = (): boolean =>
  useLocation().pathname === '/v3/pre-cart-offers';
